import CouponSetup from "@commons/coupon-setup";
import React from "react";

const AdminCouponSetup = () => {
  return <CouponSetup role="admin" />;
};

export default AdminCouponSetup;
